// @ts-strict-ignore
import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import { IonPage } from '@ionic/react'
import { getComponentParams } from '../../home/functions'
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import ScreenStoryComponent from '../components/ScreenStory'

interface ScreenStoryRouteParams {
	id: string
	locale: string
	tabIndex: string
}

const ScreenStoryRoute: FC<RouteComponentProps<ScreenStoryRouteParams>> = ({
	location: { state },
	match: { params },
}) => {
	const { id: itemId, version: itemVersion, accountId } = getComponentParams('collection', params, state)

	return (
		<IonPage>
			<ScreenStoryComponent itemId={itemId} itemVersion={itemVersion} accountId={accountId} />
		</IonPage>
	)
}

export default WithContainerRoute(ScreenStoryRoute)
